import React, { useState, useEffect, useCallback, useRef, useContext } from 'react'
import FilterListIcon from '@mui/icons-material/FilterList';
import ReplayIcon from '@mui/icons-material/Replay';
import { useTranslation } from 'react-i18next';
import { CTooltip } from '../../UI/CTooltip/CTooltip';
import AddIcon from '@mui/icons-material/Add';
import { TableAction, TableActionLink, TAContainer } from '../../../styles/Table.styled';
import { useTheme } from 'styled-components';
import UpdateRepositoryModal from "../../UI/UpdateRepositoryModal/FileManagerModal";
import { PrimaryBtnOutlineAction } from '../../../styles/Common';
import Export from '../../UI/Export/Export';
import axios from 'axios'
import Axios from "../../../axios-proas"
import { CSVLink } from "react-csv";
import ImportExportIcon from '@mui/icons-material/ImportExport';
import { AbilityContext } from '../../../ability/AbilityContext';
import { createContextualCan } from '@casl/react'
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import { getNotyfObject } from '../../../shared/utility';
const Can = createContextualCan(AbilityContext.Consumer);
function TableActions(props) {
    const { resetFilters, setShowFilters, selectedRows, showFilters, entitiesData } = props;
    const {t} = useTranslation();
    const theme = useTheme(); 
    const [csvData, setCsvData] = useState(); 
    const csvBtn = useRef();
    const [shouldDownload, setShouldDownload] = useState(false);
    const notyf = getNotyfObject();

    const [updateRepositoryShow, setUpdateRepositoryShow] = useState(false);
    const csvHeaders = [
        {
         label: t("codeGesCom"), key: "codeGesCom" },
        { label: t("raisonSociale"), key: "raisonSociale" },
        { label: t("guid"), key: "guid" },
        { label: t("apiKey"), key: "apiKey" },
        { label: t("libelleCourt"), key: "libelleCourt" },
        { label: t("telephone"), key: "telephone" },
        { label: t("url"), key: "url" },
        { label: t("adresseMail"), key: "adresseMail" },
        { label: t("opsMentionsLegales"), key: "opsMentionsLegales" },
        { label: t("opsPenalitesMailText"), key: "opsPenalitesMailText" },
        { label: t("slsMentionsLegales"), key: "slsMentionsLegales" },
        { label: t("slsPenalitesMailText"), key: "slsPenalitesMailText" },

    ];
   
    const ability = useContext(AbilityContext);

    const updateRepository = () => {
        setUpdateRepositoryShow(true);
    };
    useEffect(() => {
        if (shouldDownload && csvData && csvBtn.current) {
            csvBtn.current.link.click();
            setShouldDownload(false); // réinitialiser
        }
    }, [shouldDownload, csvData]);

    const exportCsv = useCallback(() => {
        const selectedIds = [];
      
        for (const key in selectedRows)
            if (selectedRows[key])
                selectedIds.push(key)
        Axios.get(import.meta.env.VITE_PREFIX_SERVER_API + 'bailleurs/ListAsyncWithFilter')
            .then((response) => {
              
                const csvDataTemp = response.data.bailleurs.filter((item, index) => selectedIds.includes(item.id.toString())).map(row => {
                    return { ...row }
                })

                setCsvData(csvDataTemp);
                setShouldDownload(true); 
                notyf.success("Export CSV réussi")
            }).catch(err => {
                console.log("Une erreur s'est produite")
                notyf.error("Une erreur s'est produite lors de l'export")
            })
        //setCsvData(entitiesData);
       // csvBtn.current.link.click();

    }, [selectedRows])

    const showExport = () => {
        for (const key in selectedRows) {
            if (selectedRows[key])
                return true
        }
        return false
    } 

    const formattedfileName = () => {
        const now = new Date();
        const formattedDate =
            `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}T` +
            `${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;

        const fileName = `Bailleurs_${formattedDate}.csv`;
        return fileName
    } 
    return (
        <TAContainer>
            {/*<CTooltip title={"Réinitialiser les filtres"}>*/}
            {/*    <PrimaryBtnOutlineAction*/}
            {/*        bg={theme.colors.primary}*/}
            {/*        active={showFilters}*/}
            {/*        //onClick={() => setShowFilters(!showFilters)}               */}
            {/*        onClick={() => resetFilters()}>*/}
            {/*        <span>{t("global:filters")} </span>*/}
            {/*        <FilterListOffIcon style={{ color:"white"} } />*/}
            {/*    </PrimaryBtnOutlineAction>*/}
            {/* </CTooltip>*/}
            { ability.can('add', 'Bailleur') && 
                <TableActionLink  
                    style={{ backgroundColor: theme.colors.primary }}
                    to="/entity"
                    state={{ 
                        entityFilter: "bailleur"
                    }} 
                >
                    <span>{t('tableAction:add',`Ajouter`)}</span>
                    <AddIcon style={{ color: "white" }} />
                </TableActionLink>
            }

         
            {
                <PrimaryBtnOutlineAction

                    disabled={!showExport()}
                    style={{ backgroundColor: "#00B050" }}
                    onClick={() => exportCsv()}>
                    <span>{t("global:exportCsv", "Exporter Csv")}</span>
                    <ImportExportIcon style={{ color: "white" }} />
                </PrimaryBtnOutlineAction>
            }

            {updateRepositoryShow && (
                <UpdateRepositoryModal
                    dataType="bailleurs"
                    show={updateRepositoryShow}
                    modalClosed={() => setUpdateRepositoryShow(false)}
                />
            )}

            {csvData ? (<CSVLink
                ref={csvBtn}
                data={csvData}
                filename={formattedfileName()}
                headers={csvHeaders}
                separator={";"}>
            </CSVLink>) : null}
        </TAContainer>
    )
}

export default TableActions
